import { Skeleton, Typography } from '@mui/material';
import Icon, { SizeVariant } from '@apigrowfinance/pbolt-icon';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import { RiAccountCircleLine } from 'react-icons/ri';

import PageHeaderWide from '@components/pageHeaderWide/PageHeaderWide';
type DetailsPageHeaderProps = {
    name: string;
    email: string;
    isLoading?: boolean;
};

const DetailsPageHeader = ({
    name,
    email,
    isLoading = false,
}: DetailsPageHeaderProps) => {
    const { theme } = useTheme();

    return (
        <PageHeaderWide
            icon={
                <Icon
                    data-testid="avatar"
                    sizeVariant={SizeVariant.Large}
                    avatarProps={{
                        sx: {
                            color: theme.palette.text.secondary,
                        },
                    }}
                    isLoading={isLoading}>
                    <RiAccountCircleLine />
                </Icon>
            }
            title={
                <Typography
                    variant="h3"
                    component="h1"
                    sx={{
                        color: theme?.custom?.brand?.textMain || 'text.primary',
                    }}
                    data-testid="name">
                    {isLoading ? (
                        <Skeleton width={120} data-testid="name-loader" />
                    ) : (
                        name
                    )}
                </Typography>
            }
            desc={
                <Typography variant="body1" data-testid="email">
                    {isLoading ? (
                        <Skeleton width={160} data-testid="email-loader" />
                    ) : (
                        email
                    )}
                </Typography>
            }
            showBottomRadiusBorder
            showTopRadiusBorder
        />
    );
};

export default DetailsPageHeader;
